import React from 'react';
import { Container } from 'react-bootstrap';
import { RadioGroup } from '../Radio';
import SelectableBankCard from './SelectableBankCard';
import SelectableDefaultBankCard from './SelectableDefaultBankCard';

const banksDetails = [
  { id: '1', name: 'Wells Fargo Bank', iban: '1234123412' },
  { id: '2', name: 'Bank of America', iban: '1234123412' },
];

const SelectableBankCardDemo = () => {
  const [value, setValue] = React.useState<string | number>('test-2');

  const handleChange = (e: string | number) => {
    setValue(e);
  };

  return (
    <Container className="p-0">
      <h4>Selectable Bank Card</h4>
      <Container className="p-0 mt-10 d-flex flex-wrap">
        <RadioGroup name={'test1'} value={value} onChange={handleChange}>
          {banksDetails.map((bank, i) => (
            <SelectableBankCard
              key={i}
              item={bank}
              className={'mb-7 mb-lg-0 me-lg-7'}
              selected={value === bank.id}
            />
          ))}
        </RadioGroup>
        <SelectableDefaultBankCard />
      </Container>
    </Container>
  );
};

export default SelectableBankCardDemo;
